import React, { useEffect, useState } from "react";
import {
	Box,
	Container,
	Grid,
	TextField,
	Button,
	Select,
	InputLabel,
	FormControl,
} from "@mui/material";
import Page from "../../../components/Page";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { getEscoles, getPack, updatePack } from "../../../database/API";
import { useSnackbar } from "notistack";
import Title from "../../../components/Title";

const PackView = () => {
	const navigate = useNavigate();
	const { key } = useParams();
	const { enqueueSnackbar } = useSnackbar();
	const [pack, setPack] = useState();
	const [escoles, setEscoles] = useState();

	useEffect(() => {
		const get = async () => {
			const { pack } = await getPack(key);
			console.log(pack);
			setPack(pack);
		};
		get();
	}, [key]);

	useEffect(() => {
		const get = async () => {
			const { escoles } = await getEscoles();
			setEscoles(escoles);
		};
		get();
	}, []);

	const update = async (values) => {
		const message = await updatePack(values, key);
		enqueueSnackbar(message, {
			variant: "success",
		});
		navigate(-1, { state: values });
	};

	return (
		<Page title={"Crear pack"}>
			<Container maxWidth={false}>
				<Formik
					enableReinitialize
					initialValues={{
						nom: pack?.nom,
						preu: pack?.preu,
						escola_id: pack?.escola_id,
					}}
					validationSchema={Yup.object().shape({
						nom: Yup.string()
							.required("El nom és obligatòri")
							.max(25, "Has superat el límit"),
						preu: Yup.number().required("El preu és obligatòri"),
						escola_id: Yup.number().required(
							"L'escola és obligatòria"
						),
					})}
					onSubmit={(values) => {
						update(values);
					}}
				>
					{({
						errors,
						handleBlur,
						handleChange,
						handleSubmit,
						isSubmitting,
						setFieldValue,
						touched,
						values,
					}) => (
						<form onSubmit={handleSubmit}>
							<Grid container spacing={3}>
								<Grid item size={12}>
									<Box mb={3}>
										<Title
											title={"Editar pack d'activitats"}
											subtitle={
												"Entra les dades per guardar el pack d'activitats"
											}
										/>
									</Box>
								</Grid>
							</Grid>

							<Grid container spacing={3}>
								<Grid item size={4}>
									<TextField
										error={Boolean(
											touched.nom && errors.nom
										)}
										InputLabelProps={{
											shrink: true,
										}}
										fullWidth
										helperText={touched.nom && errors.nom}
										label="Nom"
										margin="normal"
										variant="outlined"
										name="nom"
										onBlur={handleBlur}
										onChange={handleChange}
										type="text"
										value={values.nom}
									/>
								</Grid>
								<Grid item size={4}>
									<TextField
										error={Boolean(
											touched.preu && errors.preu
										)}
										InputLabelProps={{
											shrink: true,
										}}
										fullWidth
										helperText={touched.preu && errors.preu}
										label="Preu"
										margin="normal"
										variant="outlined"
										name="preu"
										onBlur={handleBlur}
										onChange={handleChange}
										type="double"
										value={values.preu}
									/>
								</Grid>
								<Grid item size={4}>
									<FormControl
										variant="outlined"
										style={{
											marginTop: 16,
											marginBottom: 15,
										}}
										fullWidth
										InputLabelProps={{
											shrink: false,
										}}
									>
										<InputLabel htmlFor="escola_id">
											Escola
										</InputLabel>
										<Select
											native
											value={values.escola_id}
											onChange={handleChange}
											onBlur={handleBlur}
											label="Escola"
											name="escola_id"
											InputLabelProps={{
												shrink: false,
											}}
											inputProps={{
												name: "escola_id",
												id: "escola_id",
											}}
										>
											<option value={null}></option>
											{escoles?.map((escola) => {
												return (
													<option
														value={escola.id}
														key={escola.id}
													>
														{escola.nom}
													</option>
												);
											})}
										</Select>
									</FormControl>
								</Grid>
							</Grid>

							<Box my={4}>
								<Button
									color="primary"
									fullWidth
									size="large"
									type="submit"
									variant="contained"
								>
									{"Guardar"}
								</Button>
							</Box>
						</form>
					)}
				</Formik>
			</Container>
		</Page>
	);
};

export default PackView;
